import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://api.kolhaupt.it/api/',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Token automatisch anhängen
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

// Fehler abfangen: bei 403 redirecten
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 403) {
            localStorage.removeItem('token');
            window.location.href = '/login'; // Hard redirect (auch außerhalb React möglich)
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;